import { InstOwnFiler, InvestorType } from './constants'

export function getQuarterAndYear(period: string) {
  const year = period.substring(0, 4)
  const quarter = period.substring(4, 6)

  return { quarter, year }
}

export function getInvestorNameFromFiler(filer?: InstOwnFiler | null) {
  if (!filer) return '-'
  switch (filer.investorType) {
    case InvestorType.Fund:
      return filer.seriesName ?? filer.filerName ?? '-'
    case InvestorType.Manager:
      return filer.filerName ?? '-'
    case InvestorType.OtherManager:
      return filer.otherManagerName ?? '-'
  }
}
